<br />
<div class="adaptive-grow-1">
    <div class="fluent-container">
        <div class="title-color">
            <h1>TODOS LOS SEGUIMIENTOS</h1>
        </div>
        <br />
        <form [formGroup]="filterForm" class="filters-container">
            <div class="line">
                <div class="column-md-3 column-lg-3 column-sm-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Fecha de seguimiento</mat-label>
                        <input
                            matInput
                            [matDatepicker]="picker"
                            placeholder="Fecha de seguimiento"
                            formControlName="date"
                            required
                            readonly
                        />
                        <mat-hint> MM/DD/AAAA </mat-hint>
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="picker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        <mat-error
                            class="for-text text-danger"
                            *ngIf="filterForm.get('date')?.hasError('required')"
                        >
                            Campo obligatorioo
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>
        <br />
        <div></div>
        <br />
        <section class="table-container mat-elevation-z1" tabindex="0">
            <div>
                <table
                    mat-table
                    [dataSource]="
                        (asyncTracking | async)?.results ?? []
                            | paginate
                                : {
                                      id: 'server',
                                      itemsPerPage: limit,
                                      currentPage: page,
                                      totalItems: total,
                                  }
                    "
                >
                    <ng-container matColumnDef="acciones">
                        <th mat-header-cell *matHeaderCellDef>Acciones</th>
                        <td mat-cell *matCellDef="let tracking">
                            <div class="action-buttons">
                                <a
                                    class="icon-button"
                                    (click)="editTracking(tracking)"
                                >
                                    <mat-icon>edit</mat-icon>
                                </a>
                                <a
                                    class="icon-button"
                                    appOnlysuperuser="/trackings"
                                    (click)="deleteTracking(tracking.id)"
                                >
                                    <mat-icon>delete</mat-icon>
                                </a>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef>Fecha</th>
                        <td mat-cell *matCellDef="let tracking">
                            {{ tracking.date | date }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="affectationKind">
                        <th mat-header-cell *matHeaderCellDef>
                            Tipo de Afectación
                        </th>
                        <td mat-cell *matCellDef="let tracking">
                            {{ tracking.affectationKind }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="affectationScope">
                        <th mat-header-cell *matHeaderCellDef>
                            Alcance de Afectación
                        </th>
                        <td mat-cell *matCellDef="let tracking">
                            {{ tracking.affectationScope }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="affectationDetail">
                        <th mat-header-cell *matHeaderCellDef>
                            Detalle de Afectación
                        </th>
                        <td mat-cell *matCellDef="let tracking">
                            {{ tracking.affectationDetail }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="commitments">
                        <th mat-header-cell *matHeaderCellDef>Compromisos</th>
                        <td mat-cell *matCellDef="let tracking">
                            {{ tracking.commitments }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="supportKind">
                        <th mat-header-cell *matHeaderCellDef>Tipo de apoyo</th>
                        <td mat-cell *matCellDef="let tracking">
                            {{ tracking.supportKind }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="supportDetail">
                        <th mat-header-cell *matHeaderCellDef>Tipo de apoyo</th>
                        <td mat-cell *matCellDef="let tracking">
                            {{ tracking.supportDetail }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="remainingSupport">
                        <th mat-header-cell *matHeaderCellDef>
                            Apoyo faltante
                        </th>
                        <td mat-cell *matCellDef="let tracking">
                            {{ tracking.remainingSupport }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="file">
                        <th mat-header-cell *matHeaderCellDef>Archivo</th>
                        <td mat-cell *matCellDef="let tracking">
                            <ng-container
                                *ngIf="hasFile(tracking); else noFile"
                            >
                                <a
                                    href
                                    (click)="
                                        openFile(tracking);
                                        $event.preventDefault()
                                    "
                                    style="
                                        cursor: pointer;
                                        text-decoration: underline;
                                    "
                                >
                                    {{ tracking.fileAttach.fileName }}
                                </a>
                            </ng-container>
                            <ng-template #noFile
                                ><span>No disponible</span></ng-template
                            >
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: showColumns"
                        class="highlight-row"
                    ></tr>
                </table>
            </div>
        </section>

        <pagination-controls
            (pageChange)="fetchTracking($event)"
            previousLabel="Anterior"
            nextLabel="Siguiente"
            id="server"
        ></pagination-controls>
    </div>
</div>
